import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { RankListItemMessage, RankListResponseWrapper } from "src/app/api/models";

export const lastplayersEntityKey = 'lastplayers';

export interface LastplayersEntity extends RankListResponseWrapper { }

export interface LastplayersState extends EntityState<LastplayersEntity> { }

export const adapter: EntityAdapter<LastplayersEntity> = createEntityAdapter<LastplayersEntity>();

const initialLastplayersState: LastplayersState = adapter.getInitialState(
    {} as LastplayersState,
);

export function getInitialLastplayersState(): LastplayersState {
    return initialLastplayersState;
}